export const DASH = '-'
export const DEFAULT_ICON_WIDTH  = 512
export const DEFAULT_ICON_HEIGHT = 512